import { Control, FieldValues } from 'react-hook-form';
import {
    FormInputText,
    FormUploadFile,
    Grid,
    Typography,
} from '../../../base';
import { UploadFileTypes } from '../../../common';
import { useTranslation } from 'react-i18next';

interface Props {
    control: Control<FieldValues>;
}

const UserInformationTab = ({ control }: Props) => {
    const { t } = useTranslation();

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="subtitle2">
                            {t('userSettings.userInformation.profilePicture')}
                        </Typography>
                        <FormUploadFile
                            name="userProfilePicture"
                            type={UploadFileTypes.image}
                            enableEditor={true}
                            initialAspectRatio={1}
                            maxWidth={800}
                            maxHeight={800}
                            quality={0.92}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormInputText
                            name="firstName"
                            control={control}
                            label={t('userSettings.userInformation.firstName')}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormInputText
                            name="lastName"
                            control={control}
                            label={t('userSettings.userInformation.lastName')}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormInputText
                            name="userTitle"
                            control={control}
                            label={t('userSettings.userInformation.title')}
                            placeholder={t(
                                'userSettings.userInformation.titlePlaceholder'
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormInputText
                            name="userGender"
                            control={control}
                            label={t('userSettings.userInformation.gender')}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormInputText
                            name="userEmail"
                            control={control}
                            label={t('userSettings.userInformation.email')}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormInputText
                            name="userPhoneNumber"
                            control={control}
                            label={t('userSettings.userInformation.phoneNumber')}
                        />
                    </Grid>
                </Grid>
            </Grid>

            {/* Right side - reserved for future use */}
            <Grid item xs={12} md={4} />
        </Grid>
    );
};

export default UserInformationTab;
